import { SET_NAVIGATION } from "./types";
export default location => async dispatch => {
  dispatch(getAsync(location));
};
const getAsync = data => ({
  type: SET_NAVIGATION,
  payload: data
});
